module.exports = __webpack_public_path__ + "static/Wilker-Mecenas-e302ee880a4fb64c211a99bc900c618b.jpg";